<template lang="pug" @touchmove="(e) => e.preventDefault()">
.buy-card-modal(v-if="show"  @touchmove="(e) => e.preventDefault()")
  .card-modal-block
    .card-title {{ showName }}
      .card-subtitle
    .card-word(v-if="haveContinuousMounth")
      .card-word-list(v-for="item in wordList")
        span.card-word {{ item.wordsValue }} /
        span.card-small-word {{ item.wordsDesc }}
    .card-word(v-if="!haveContinuousMounth")
      .card-word-list(v-for="item in wordList")
        span.card-word {{ item.wordsValue }} /
        span.card-small-word {{ item.wordsDesc }}
    .card-btn
      .one-mouth(v-if="buyCardDataList === 1" @click="buyCard(isOne, buyCardDataList)")
        span ¥
        span.big-word {{parseFloat(buyObj.actualPrice.finalPrice)}}
        span 购买
      .more-mouth(v-else)
        .more-mouth-one(@click="buyCard(isOne,null)")
          .more-mouth-line-one
            span 开通1个月
            span.blue-small ¥
            span.blue-big {{parseFloat(oneMounth.actualPrice.finalPrice)}}
          .more-mouth-line-two 日常价¥{{parseFloat(oneMounth.originPrice)}}
        .more-mouth-two(@click="buyCard(!isOne,null)")
          .more-mouth-two-one
            span 连续包月¥
            span.big-font {{parseFloat(continuousMounth.actualPrice.finalPrice)}}
          .more-mouth-two-two 次月起¥{{parseFloat(continuousMounth.purchasePrice)}}/月续费
      .agreement(v-if="agreementInfo.isShowAgreement") 购卡即视为已阅并同意
        .agreement-item(@click="jumpToAgreement") 《{{agreementInfo.agreementTitle}}》
    .close-btn(@click="closeModal")
      img(src="https://m.hellobike.com/resource/gallery/61/_R0CJDtep6.png?x-oss-process=image/quality,q_80")
  .shadow(@click="closeModal"  @touchmove="(e) => e.preventDefault()")
</template>
<script>
import {
  getNoScroll,
} from '@/utils';
import { CardService } from '@/service/card';
import eventBus from '@/const/eventBus.js';
import Toast from '@/components/toast';
import { Navigator } from '@hb/h5-navigator';
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import { debounce } from '@/utils/index';
import TransTab from '../transTab.vue';

export default {
  inject: ['latestTabCode'],
  components: {
    TransTab,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    buyCardData: {
      type: Array,
      default: () => [],
    },
    agreementInfo: {
      type: Object,
      default() {
        return {
          isShowAgreement: false,
        };
      },
    },
  },
  data() {
    return {
      signInfoDTO: {

      },
      continuousMounth: {},
      oneMounth: {},
      haveContinuousMounth: null,
      isOne: true, // 单月
      params: {},
      wordList: [],
      buyObj: {},
      showName: '',
    };
  },
  watch: {
    buyCardData(val) {
      const tempArr = val.filter((i) => i.paymentLimit === 1);
      const tempList = val.filter((i) => i.paymentLimit === 0);
      this.buyCardDataList = val.length;

      if (tempArr.length > 0) {
        // eslint-disable-next-line prefer-destructuring
        this.continuousMounth = tempArr[0];
        this.haveContinuousMounth = true;
        this.showName = this.continuousMounth.showName;
        if (this.continuousMounth.marketingWords && Array.isArray(this.continuousMounth.marketingWords)) {
          this.wordList = this.continuousMounth.marketingWords.filter((item) => item.wordsValue !== 1);
        } else {
          this.wordList = [];
        }
      }

      if (tempArr.length === 0 && tempList.length > 0) {
        // eslint-disable-next-line prefer-destructuring
        this.oneMounth = tempList[0];
        this.haveContinuousMounth = false;
        if (this.oneMounth.marketingWords && Array.isArray(this.oneMounth.marketingWords)) {
          this.wordList = this.oneMounth.marketingWords.filter((item) => item.wordsValue !== 1);
        } else {
          this.wordList = [];
        }
        this.showName = this.oneMounth.showName;
      }
      if (tempList.length > 0) {
        // eslint-disable-next-line prefer-destructuring
        this.oneMounth = tempList[0];
        if (this.oneMounth.marketingWords && Array.isArray(this.oneMounth.marketingWords)) {
          this.wordList = this.oneMounth.marketingWords.filter((item) => item.wordsValue !== 1);
        } else {
          this.wordList = [];
        }
        this.showName = this.oneMounth.showName;
      }

      if (val && Array.isArray(val) && val.length === 1) {
        // eslint-disable-next-line prefer-destructuring
        this.buyObj = val[0];
        this.showName = this.buyObj.showName;
      }
    },
    show: {
      handler(val) {
        if (val) {
          this.agreementInfoUBT();
        }
      },
      immediate: true,
    },
  },
  mounted() {
  },
  methods: {
    /**
     * 购卡协议曝光埋点
     */
    agreementInfoUBT() {
      if (this.agreementInfo && this.agreementInfo.isShowAgreement) {
        UBT.moduleExpose({
          pageId: 'platform_savemoneycard_page',
          categoryId: 'platform',
          moduleId: 'platform_xieyi',
          contentId: 'platform_xieyi',
          exposureTimes: 1,
          businessInfo: {},
        });
      }
    },
    /**
     * 跳转协议
     */
    jumpToAgreement() {
      Navigator.go(this.agreementInfo.agreementUrl || '');
    },
    closeModal() {
      getNoScroll(false);
      this.$emit('update:show', false);
    },
    buyCard: debounce(function buyCardClick(isOne, leng) {
      let tempObj = {};
      if (leng === 1) {
        tempObj = this.buyObj;
      } else if (isOne) {
        tempObj = this.oneMounth;
      } else {
        tempObj = this.continuousMounth;
      }

      const tabCode = this.latestTabCode();
      this.params = {
        businessType: (tabCode === 'bike' ? 1 : 2),
        channelCode: tempObj.channelCode,
        adSource: (tabCode === 'bike' ? 'VIPbikecard' : 'VIPebikecard'),
      };
      // 直接调接口
      CardService.buy(tempObj, this.params || {}).then(() => {
        eventBus.$emit('refreshNewMember');
        Toast.show('支付成功');
        this.closeModal();
      });
    }, 300),
  },
};
</script>
<style lang="less" scoped>
.buy-card-modal {
  .card-modal-block {
    position: fixed;
    bottom: 0;
    z-index: 222;
    height: 4.45rem;
    width: 100%;
    background: #fff;
    border-radius: 0.12rem 0.12rem 0 0;

    .card-title {
      height: 0.77rem;
      background: linear-gradient(178.11deg, #daedff 4.36%, #fff 97.18%);
      padding: 0.16rem;
      font-family: PingFang SC;
      font-size: 0.18rem;
      font-weight: 600;
      line-height: 0.252rem;
      border-radius: 0.12rem 0.12rem 0 0;

      .card-subtitle {
        font-family: PingFang SC, sans-serif;
        font-size: 12px;
        font-weight: 400;
        line-height: 16.8px;
        color: #5a6066;
      }
    }

    .card-word {
      margin-top: 0.19rem;
      padding-left: 0.18rem;
      padding-right: 0.14rem;
      text-align: left;

      .card-word-list {
        margin-bottom: 0.16rem;
        font-size: 0.13rem;
        font-family: PingFang SC, sans-serif;
        font-weight: 400;
        color: #242729;

        span.card-word {
          padding: 0;
          font-weight: 700;
        }
      }
    }

    .card-btn {
      position: absolute;
      bottom: 0;
      height: 1.24rem;
      width: 100%;
      box-shadow: 0 -0.02rem 0.12rem 0 #00000012;
      padding: 0 0.2rem;

      .one-mouth {
        width: 100%;
        height: 0.48rem;
        border-radius: 0.12rem;
        text-align: center;
        line-height: 0.48rem;
        background: #08f;
        color: #fffaeb;
        margin: 0.16rem auto 0 auto;
        font-size: 0.14rem;
        font-weight: 600;

        span.big-word {
          display: inline-block;
          font-size: 0.22rem;
          font-weight: 700;
          font-family: DIN Alternate Bold, sans-serif;
          margin: 0 0.02rem;
        }
      }

      .more-mouth {
        display: flex;
        justify-content: space-between;
        margin-top: 0.16rem;
        text-align: center;

        .more-mouth-one {
          width: 1.45rem;
          height: 0.48rem;
          border: 0.01rem solid #0098ff;
          border-radius: 0.12rem;
          background: #ecf8ff;

          .more-mouth-line-one {
            margin-top: 0.09rem;
            font-family: PingFang SC;
            font-size: 0.14rem;
            font-weight: 500;
            line-height: 0.196rem;

            span.blue-small {
              color: #0098ff;
            }

            span.blue-big {
              color: #0098ff;
              font-size: 0.22rem;
              font-weight: 700;
              font-family: DIN Alternate Bold, sans-serif;
            }
          }

          .more-mouth-line-two {
            font-family: PingFang SC;
            font-size: 0.1rem;
            font-weight: 400;
            line-height: 0.12rem;
            text-decoration: line-through;
            color: #879099;
          }
        }

        .more-mouth-two {
          width: 1.75rem;
          height: 0.48rem;
          border-radius: 0.12rem;
          background: #0098ff;

          .more-mouth-two-one {
            margin-top: 0.04rem;
            color: #fffae8;
            font-weight: 600;
            font-size: 0.14rem;
            line-height: 0.196rem;

            span.big-font {
              font-size: 0.22rem;
              font-family: din Alternate Bold, sans-serif;
              line-height: 0.24rem;
            }
          }

          .more-mouth-two-two {
            font-family: PingFang SC;
            font-size: 0.1rem;
            font-weight: 400;
            line-height: 0.14rem;
            color: #fff;
          }
        }
      }
    }

    .agreement {
      font-weight: 400;
      font-size: 0.12rem;
      color: #242729;
      display: flex;
      align-items: center;
      justify-content: center;
      padding-top: 0.1rem;

      .agreement-item {
        color: #08f;
      }
    }
  }

  .close-btn {
    position: absolute;
    top: 0.14rem;
    right: 0.13rem;

    img {
      width: 0.16rem;
      height: 0.16rem;
    }
  }

  .shadow {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: #000;
    opacity: 0.7;
    z-index: 220;
  }
}
</style>
